import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@carvana/showroom-modal';
import { DefaultModalWrapper, Button, Heading, Content } from './DefaultModal.styles';


class DefaultModal extends React.Component {
  state = {
    openModal: true
  }

  closeModal = () => {
    this.setState({
      openModal: !this.state.openModal
    });
  }

  render() {
    const { dismissUserNotification } = this.props;
    dismissUserNotification();
    return (
      <Modal
        headerText="Action Needed"
        closeModal={this.closeModal}
        isOpen={this.state.openModal}
        testHook="test-modal"
      >
        <DefaultModalWrapper>
          <Heading>Please update your terms</Heading>

          <Content>
          Your financing terms have expired.  <br />
          Reapply for personalized terms across every car in our inventory.
          </Content>
          <a href="/financing-prequalification">
            <Button variant="primary" selectedTheme="light">get new terms</Button>
          </a>
        </DefaultModalWrapper>
      </Modal>
    );
  }
}

DefaultModal.propTypes = {
  dismissUserNotification: PropTypes.func.isRequired
};

export default DefaultModal;
